export default "__VITE_ASSET__BODKjBbc__"